import { Card, Checkbox } from "antd";
import { useState } from "react";

interface Props {
  data: any;
  viewOnly?: boolean;
}

export default function DetailsTemplateCheckbox({ data, viewOnly }: Props) {
  const [value, setValue] = useState<number[]>(data?.answer);

  return (
    <>
      <Card className="mt-4">
        <div className="self-stretch justify-start text-zinc-700 text-base font-medium">
          {data?.question_title}
        </div>
        <div className="mt-4">
          <Checkbox.Group
            style={{ display: "flex", flexDirection: "column", gap: 10 }}
            onChange={(e) =>
              data?.answer || viewOnly
                ? setValue(data?.answer || [])
                : setValue(e)
            }
            value={data?.answer || value}
            options={
              data?.question_choices?.map((choice: any) => ({
                value: choice,
                label: choice,
              })) || []
            }
          />
        </div>
      </Card>
    </>
  );
}
